Librarian.Modules.Rss = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-rss-",
        url: "https://news.yahoo.com/rss/",
        method: "readrssfeed",
        requiresAuthentication: false,
        username: "",
        password: "",
        showThumbnail: true,
        limit: "",
        customFormat: null,
        linkPrefix: ""
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        // Create the container element and generate the URL
        var self = this,
            listEl = new Element("ul").injectInside(this.containerEl),
            url = Librarian.path.getMethodUrl(this.options.method) + "&out=cjson&url=" + encodeURIComponent(this.options.url) + "&rssauth=" + this.options.requiresAuthentication;

        if (this.options.requiresAuthentication)
            url += "&rssuname=" + this.options.username + "&rsspwd=" + this.options.password;

        this.request = new Librarian.Request.JSON({
            url: url,
            onSuccess: function(json) {
                if (!json)
                    return;

                if (typeof json != "object") {
                    var data = JSON.parse(json);
                    for (var i = 0, length = data.length; i < length; i++) {
                        self.renderItem(data[i], listEl);
                    }
                }

                else {
                    var feedData = json.entries,
                        content,
                        length = feedData.length;

                    listEl.empty();

                    if ((typeof this.options.limit == "number") && (this.options.limit >= 0))
                        length = Math.min(length, this.options.limit);

                    for (var i = 0; i < length; i++) {
                        if (!this.options.showThumbnail)
                            content = this.removeImages(feedData[i].content);
                        else
                            content = feedData[i].content;

                        // Replace encoded NBSPs in the content
                        content = content.replaceAll("&amp;nbsp;", ' ');
                        
                        if (this.options.customFormat && typeOf(this.options.customFormat) == "function") {
                            content = this.options.customFormat(content);
                        }

                        var listItemEl = new Element("li", {
                                "class": "rss-feed"
                            }).injectInside(listEl),
                            rssHeading = new Element("h2", {

                            }).injectInside(listItemEl);

                        new Element("a", {
                            "class": "rss-title",
                            "href": feedData[i].links ? feedData[i].links[0] : '#',
                            "target": '_' + (new Date()).getTime(),
                            "text": feedData[i].title
                        }).injectInside(rssHeading);

                        var dateText = '';
                        if (feedData[i].authors && (feedData[i].authors.length > 0))
                            dateText = "By: " + feedData[i].authors.map(function(item) {
                                return item.name || item.email;
                            }).join(", ");

                        if (feedData[i].publishedDate) {
                            if (dateText.length > 0)
                                dateText += ' ';
                            dateText += "Posted on: " + new Date(feedData[i].publishedDate).format("%x %X");
                        }

                        new Element("div", {
                            "class": "rss-date",
                            "html": dateText
                        }).injectInside(rssHeading);
                        new Element("div", {
                            "html": content,
                            "class": "rss-content"
                        }).injectInside(listItemEl);
                    }
                }
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        });
        this.request.send();
    },

    renderItem: function (item, listEl) {
        if (!item)
            return;

        var header = (item.header || '').trim();
        if (header.length > 0) {
            var headerEl = new Element("li", {
                "class": "rss-feed-header"
            }).injectInside(listEl);
            new Element("h2", {
                "text": header
            }).injectInside(headerEl);
        }

        if (!item.items)
            return;

        for (var i = 0, length = item.items.length; i < length; i++)
            this.renderSubItem(item.items[i], listEl);
    },

    renderSubItem: function (item, listEl) {
        if (!item)
            return;

        var contEl = new Element("li", {
            "class": "rss-feed"
        }).injectInside(listEl);

        var headerEl = new Element("h2").injectInside(contEl);
        var linkEl = new Element("a", {
            "href": this.options.linkPrefix + item.link || '#',
            "target": "_blank"
        }).injectInside(headerEl);
        new Element("span", {
            "class": "rss-title content-header",
            "text": (item.title || '').trim()
        }).injectInside(linkEl);

        var subTitle = (item.subTitle || '').trim();
        if (subTitle.length > 0) {
           new Element("div", {
                "class": "rss-date",
                "text": subTitle
            }).injectInside(headerEl);
        }

        var bodyEl = new Element("div", {
            "class": "rss-content"
        }).injectInside(contEl);
        var nodeEl = new Element("div", {
            "class": "node-body article-body"
        }).injectInside(bodyEl);
        new Element("p", {
            "text": (item.text || '').trim()
        }).injectInside(nodeEl);
    },

    removeImages: function(content) {
        var contentEl = new Element("div", {
            "html": content
        });

        contentEl.getElements("a > img").getParent().destroy();
        contentEl.getElements("img").destroy();

        return contentEl.get("html");
    }
});